type StatusType =
  | "draft"
  | "branch finance submitted"
  | "branch account approved"
  | "branch account request change"
  | "ho request change"
  | "ho approved"
  | "rejected";

export const STATUS_COLOR: Record<StatusType, string> = {
  draft: "#D9D9D9",
  "branch finance submitted": "#FDA42C",
  "branch account approved": "#FDA42C",
  // Same blue as its HO twin: both mean "a reviewer sent this back".
  "branch account request change": "#5C69E8",
  "ho request change": "#5C69E8",
  "ho approved": "#45BE77",
  rejected: "#FB3B3B",
};

export const STATUS_LABEL: Record<StatusType, string> = {
  draft: "ฉบับร่าง",
  "branch finance submitted": "รอบัญชีตรวจสอบ",
  "branch account approved": "รอ HO ตรวจสอบ",
  "branch account request change": "บัญชีขอแก้ไข",
  "ho request change": "รอการแก้ไข",
  "ho approved": "HO ตรวจสอบแล้ว",
  rejected: "ไม่อนุมัติ",
};
